const creditsFR = {
    "view": {
        "form": {
            "title": "Commander des crédits",
            "label": {
                "quantity": "Quantité"
            },
            "placeholder": {
                "quantity": "Sélectionner la quantité"
            },
            "help_text": {
                "quantity": "Montant des crédits que vous souhaitez commander."
            },
            "button": {
                "placeOrder": "Passer la commande"
            },
            "options": {
                "quantity": {
                    "selectQuantity": "Sélectionner la quantité",
                    "1Credit": "1 Crédit",
                    "2Credits": "2 Crédits",
                    "3Credits": "3 Crédits",
                    "4Credits": "4 Crédits",
                    "5Credits": "5 Crédits",
                    "10Credits": "10 Crédits",
                    "15Credits": "15 Crédits",
                    "20Credits": "20 Crédits",
                    "25Credits": "25 Crédits",
                    "30Credits": "30 Crédits",
                    "35Credits": "35 Crédits",
                    "40Credits": "40 Crédits",
                    "45Credits": "45 Crédits",
                    "50Credits": "50 Crédits",
                    "75Credits": "75 Crédits",
                    "100Credits": "100 Crédits"
                }
            },
            "message": {
                "quantityRequired": "La quantité est requise",
                "paymentMethodRequired": "Veuillez ajouter un <1>moyen de paiement</1> pour passer commande pour des crédits.",
                "paymentMethodExpired": "Vous ne pouvez pas passer commande pour des crédits car votre <1>moyen de paiement</1> par défaut a expiré, veuillez définir un moyen de paiement valide par défaut pour passer commande pour des crédits."
            }
        },
        "modal": {
            "header": "Procéder au paiement",
            "body": {
                "message": "Vous avez commandé {{credits}} Crédits",
                "confirmationMessage": "Si vous souhaitez confirmer la commande, veuillez procéder au paiement, sinon vous pouvez annuler la commande."
            },
            "button": {
                "cancel": "Annuler",
                "checkout": "Paiement"
            }
        },
        "message": {
            "error": "Quelque chose a mal tourné ! Veuillez actualiser la page et réessayer !"
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transaction réussie :)",
            "description": "Vous avez acheté avec succès les crédits qui seront bientôt ajoutés à votre compte !",
            "button": {
                "returnToDashboard": "Retour au tableau de bord"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transaction annulée :(",
            "description": "La transaction a été annulée... Veuillez réessayer plus tard !",
            "button": {
                "returnToDashboard": "Retour au tableau de bord"
            }
        }
    }
};

export default creditsFR;